import React, { useState } from 'react';
import './SuccessStoriesSection.css';

const SuccessStoriesSection = () => {
  // Updated data with unique identification to avoid image repetition issues
  const allSuccessStories = [
    {
      id: 1,
      title: "SIH 2023",
      image: "/assets/success-stories/SIH.png"
    },
    {
      id: 2,
      title: "NASA Space Challenge",
      image: "/assets/success-stories/NASA.jpg"
    },
    {
      id: 3,
      title: "Google Agentic AI",
      image: "/assets/success-stories/google.jpg"
    },
    {
      id: 4,
      title: "Hack Nation",
      image: "/assets/success-stories/hack nation.jpg"
    },
    {
      id: 5,
      title: "SIH 2025 Evaluation",
      image: "/assets/success-stories/sih evaluvator.png"
    },
    {
      id: 6,
      title: "Accenture Innovation Challenge",
      image: "/assets/success-stories/accenture.jpg"
    },
    {
      id: 7,
      title: "AI Builder Lab",
      image: "/assets/success-stories/Ai builder lab.png"
    },
    {
      id: 8,
      title: "Bharathiya Antharix Hacathon",
      image: "/assets/success-stories/BAH.jpg"
    },
    {
      id: 9,
      title: "IBM Z",
      image: "/assets/success-stories/IBM Z.jpg"
    },
    {
      id: 10,
      title: "Integration for AI GenAI Hackathon 2025",
      image: "/assets/success-stories/Integration for AI GenAI Hackathon 2025.png"
    },
    {
      id: 11,
      title: "ML Fiesta AI ML Hackathon",
      image: "/assets/success-stories/ML Fiesta AI ML Hackathon.png"
    },
    {
      id: 12,
      title: "AI for Impact",
      image: "/assets/success-stories/ai for impact.png"
    },
    {
      id: 13,
      title: "Build Fest",
      image: "/assets/success-stories/build fest.jpg"
    },
    {
      id: 14,
      title: "Gen AI",
      image: "/assets/success-stories/gen ai.jpg"
    },
    {
      id: 15,
      title: "Hack India",
      image: "/assets/success-stories/hack india.png"
    },
    {
      id: 16,
      title: "Master Union",
      image: "/assets/success-stories/master union.jpg"
    },
    {
      id: 17,
      title: "Pragathi",
      image: "/assets/success-stories/pragathi.jpg"
    },
    {
      id: 18,
      title: "Imobilathon Volks Vagon",
      image: "/assets/success-stories/imobilathon.jpg"
    }
  ];

  const [showAll, setShowAll] = useState(false);
  
  // Show only first 3 items initially, or all items if showAll is true
  const displayedStories = showAll ? allSuccessStories : allSuccessStories.slice(0, 3);

  return (
    <section className="success-stories-section" id="success-stories">
      <div className="container">
        <h2 className="section-title">Success Stories</h2>
        <p className="section-subtitle">Our achievements and participation</p>
        
        <div className="stories-grid">
          {displayedStories.map((story) => (
            <div key={story.id} className="story-card">
              <div className="story-image">
                <img src={story.image} alt={story.title} onError={(e) => {
                  e.target.src = '/assets/images/placeholder-image.jpg'; // Fallback image
                }} />
              </div>
              <div className="story-content">
                <h3 className="story-title">{story.title}</h3>
              </div>
            </div>
          ))}
        </div>
        
        {/* Show More Button */}
        {!showAll && (
          <div className="show-more-container">
            <button className="btn-primary show-more-btn" onClick={() => setShowAll(true)}>
              Show More
            </button>
          </div>
        )}
        
        {/* Show Less Button when all items are shown */}
        {showAll && (
          <div className="show-less-container">
            <button className="btn-secondary show-less-btn" onClick={() => setShowAll(false)}>
              Show Less
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default SuccessStoriesSection;